import { proxy } from "valtio"

// -- Helpers -------------------------------------------------------
let interval: NodeJS.Timeout | undefined

// -- Types ---------------------------------------------------------
type ClockStateType = {
  date: Date
}

// -- State ---------------------------------------------------------
const INITIAL_STATE: ClockStateType = {
  date: new Date(),
}

export const ClockState = proxy<ClockStateType>(INITIAL_STATE)

// -- Actions -------------------------------------------------------
export const ClockActions = {
  startClock() {
    if (!interval) {
      interval = setInterval(() => {
        ClockState.date = new Date()
      }, 1000)
    }
  },
}
